define([
  'underscore'
], function (
  _
) {

  function loadHTMLAsync(path) {
    return new Promise(function(resolve, reject) {
      Mindbreeze.require(["text!" + path], function(fragmentText) {
        resolve(fragmentText);
      });
    });
  }

  function tryGetDescriptor(el, ctx) {
    var descriptorEl = el.querySelector("script[type='application/json'][data-name=descriptor]");
    if (descriptorEl) {
      try {
        return JSON.parse(descriptorEl.innerText);
      } catch (e) {
        console.warn("Failed to parse descriptor, skipping.", ctx, e);
      }
    }
    return null;
  }

  function tryGetSchema(el, ctx) {
    var schemaText = el.getAttribute("data-schema");
    if (!schemaText) {
      var schemaEl = el.querySelector("template[data-name=schema]");
      if (schemaEl) {
        schemaText = schemaEl.innerHTML;
      }
    }
    return tryParseSchema(schemaText, ctx);
  }
  
  function tryParseSchema(schemaString, ctx) {
    ctx = ctx || "";
    if (schemaString) {
      try {
        return JSON.parse(schemaString);
      } catch (e) {
        console.warn("Failed to parse schema, skipping.", ctx, e);
      }
      return null;
    }            
    return null;
  }

  function buildFragment(templateEl, appfragment, ctx) {
    var baseDescriptor = tryGetDescriptor(templateEl, ctx) || {};
    var schema = tryGetSchema(templateEl, ctx);
    if (schema) {
      baseDescriptor.schema = schema;
    }
    appfragment.storeProperties = { storeId: "readonlyDOMAppFragmentStoreAPI", writeable: false };
    return _.extend(baseDescriptor, appfragment);
  }
  
  function ReadonlyDOMAppFragmentStoreAPI(options) {
    this.options = options || {};
    if (this.options.location) {
      this.documentPromise = loadHTMLAsync(this.options.location).then(function (resolved, rejected) {
        if (resolved) {
          var el = document.createElement("template");
          el.innerHTML = resolved;
          return el.content;          
        }
      });
    }
    else {
      this.documentPromise = Promise.resolve(options.el || document);
    }
  }


   

  _.extend(ReadonlyDOMAppFragmentStoreAPI.prototype, {

    get: function (id) {
      return this.fragmentList.find(function (fragment) { fragment.id === id });
    },

    findFirstByTypeAndNames: function (appType, appNames) {

      var templateElement = null;
      return this.documentPromise.then(function (rootEl) {
        var appName = null;
        for (var i = 0; i < appNames.length; ++i) {
          appName = appNames[i];
          templateElement = rootEl.querySelector('[data-app-fragment-type="' + appType + '"][data-app-fragment-name="' + appName + '"]');
          if (templateElement) {
            break;
          }
        }

        return new Promise(function (resolve, reject) {
          if (!templateElement) {
            reject({});
          }
          else {
            var ctx = "app=" + appType + "." + appName;
            resolve(buildFragment(
              templateElement,
              {
                id: templateElement.id,
                type: appType,
                name: appName,
                htmlFragment: templateElement.innerHTML,
              },
              ctx));
          }
        });
      });
    },

    getByTypeAndName: function (appType, appName) {
      return this.documentPromise.then(function (rootEl) {

        var templateElement = rootEl.querySelector('[data-app-fragment-type="' + appType + '"][data-app-fragment-name="' + appName + '"]');
        return new Promise(function (resolve, reject) {
          if (!templateElement) {
            reject({});
          }
          else {
            var ctx = "app=" + appType + "." + appName;
            resolve(buildFragment(
              templateElement,
              {
                id: templateElement.id,
                type: appType,
                name: appName,
                htmlFragment: templateElement.innerHTML,
              },
              ctx));
          }
        });
      })
    },
                                      

    getAllAppDescriptions: function (appType, options) {

      return this.documentPromise.then(function (rootEl) {
          
        return new Promise(function(res, rej) {
          var selector = '[data-app-fragment-type]';
          if (appType) {
            selector = '[data-app-fragment-type="' + appType + '"]';
          }
          
          var templateElements = rootEl.querySelectorAll(selector);
          
          if (!templateElements.length) {
            return res([]);
          } else {
            const listItemsArray = Array.from(templateElements);
            var list = listItemsArray.map(function(templateElement) {
              var appType = templateElement.getAttribute('data-app-fragment-type');
              var appName =  templateElement.getAttribute('data-app-fragment-name');
              var ctx = "app=" + appType + "." + appName;
              return buildFragment(
                templateElement,
                {
                  id: templateElement.id,
                  type: appType,
                  name: appName,
                  htmlFragment: templateElement.innerHTML,
                },
                ctx);
            });
            return res(list);
          }
        });
      });
    },

    getStoreId: function() {
      return "readonlyAppFragmentStore";
    },
  
    isWriteable:function() {
      return false;
    }

  });

  return ReadonlyDOMAppFragmentStoreAPI;
});
